<template>
  <div class="miles_3_container">
    <div class="miles_3_top">
      <div class="miles_3_title">Fabrication</div>
<!--      <el-dropdown trigger="click" @command="handleCommand">-->
<!--        <el-button style="font-size: 1rem; width: 105px; display: flex;background-color: transparent;border-width: 0px">-->
<!--          <div-->
<!--            style="width: 80px; height: 1rem; text-align: left; white-space: nowrap;text-overflow: ellipsis;overflow: scroll; padding: 0; margin: 0;color:#ccc">-->
<!--            {{ block_name }}<i class="el-icon-arrow-down el-icon&#45;&#45;right"></i>-->
<!--          </div>-->
<!--        </el-button>-->
<!--        <el-dropdown-menu style="transform-origin: left; width: 105px;color: transparent" slot="dropdown">-->
<!--          <el-dropdown-item-->
<!--            style="font-size: 1rem;white-space: nowrap;text-overflow: ellipsis;overflow: auto;"-->
<!--            v-for="(block, index) in block_list" :command=block :key="'key_' + index">-->
<!--            {{ block.block }}-->
<!--          </el-dropdown-item>-->
<!--        </el-dropdown-menu>-->
<!--      </el-dropdown>-->
    </div>
    <div class="miles_3_content">
      <div style="height: 100%; width: 100%" id="miles_3_bar"></div>
    </div>
  </div>
</template>

<script>
import echarts from "echarts";
import axios from "axios"

export default {
  name: "milestones_3",
  props: ['block_list', 'template_id', 'project_id', 'block_name', 'level_name'],
  data() {
    return {
      block_id: '',
      // block_name: 'ALL',
      my_block_name: this.block_name,
      my_template_id: this.template_id,
      my_level_name: this.level_name,
      fabrications: [
        {name: 'Cast', plan: 1200, actual: 1000},
        {name: 'Fit out', plan: 900, actual: 800},
        {name: 'Received', plan: 650, actual: 600},
        {name: 'Installed', plan: 300, actual: 300},
      ]
    }
  },
  methods: {
    init() {
      // var that = this
      // if (that.block_list.length > 0) {
      //   that.block_name = that.block_list[0].block
      // }
      // that.$nextTick(function () {
      // this.block_name = "ALL"
      // this.template_id = "13"
      // that.drawBar()
      // })
    },
    drawBar() {
      var that = this
      let postData = {
        project_id: this.project_id,
        user: window.localStorage.getItem("token_key"),
        token: window.localStorage.getItem('token'),
        template_id: that.my_template_id,
        block: that.my_block_name,
        level: that.my_level_name
        // startdate: that.date,
        // enddate: that.date
      }
      axios.post(this.$store.getters.getCmsServer + "DBProjFaStage", postData).then(resp => {
        var errNo = resp.data.errno
        var errStr = resp.data.errstr_cn
        if (errNo == "0") {
          this.piedataNotNull = true
          var result = resp.data.result
          let chart = echarts.init(document.getElementById('miles_3_bar'))
          chart.setOption({
            legend: {
              data: ['Plan', 'Actual'],
              right: 0,
              orient: 'vertical',
              textStyle: {
                color: 'white'
              }
            },
            grid: {
              top: '15%',
              right: '20%',
              bottom: '15%',
              left: '5%',
            },
            xAxis: [
              {
                type: 'category',
                data: ['Cast', 'Fit out', 'Received', 'Installed'],
                axisLabel: {
                  color: '#FFFFFF',
                  fontSize: 10
                },
                axisLine: {
                  lineStyle: {
                    color: '#797979',
                    width: 3
                  }
                },
                axisTick: {
                  show: false
                }
              }
            ],
            yAxis: [
              {
                type: 'value',
                axisLabel: {
                  show: false
                },
                axisLine: {
                  lineStyle: {
                    color: '#797979',
                    width: 3
                  }
                },
                axisTick: {
                  show: false
                },
                splitLine: {
                  show: false
                }
              }
            ],
            series: [
              {
                name: 'Actual',
                type: 'bar',
                data: result.actual,
                label: {
                  normal: {
                    show: true,
                    color: 'red',
                    fontSize: 9
                  }
                },
                barWidth: 28,
                itemStyle: {
                  normal: {
                    color: function (params) {
                      return ['#FFFFFF', '#FF89F7', '#0073BF', '#009755'][params.dataIndex]
                    }
                  },
                  //鼠标悬停时：
                  emphasis: {
                    shadowBlur: 10,
                    shadowOffsetX: 0,
                    shadowColor: 'rgba(0, 0, 0, 0.5)',
                    borderWidth: 1,
                  }
                },
              },
              {
                name: 'Plan',
                type: 'line',
                data: result.plan,
                label: {
                  normal: {
                    show: true,
                    color: 'white',
                    fontSize: 9
                  }
                },
              }
            ]
          })
        } else {
          // this.piedataNotNull = false
        }
      }).catch(error => {
        // this.piedataNotNull = false
      })

    },
    handleCommand(command) {
      if (this.block_name != command.block) {
        this.block_name = command.block
        this.drawBar()
      }
    }
  },
  created() {
    this.init()
  },
  watch: {
    template_id(curVal, oldVal) {
      if (curVal) {
        this.my_template_id = curVal
        this.my_block_name = 'ALL'
        this.my_level_name = 'ALL'
        this.drawBar()
      }
    },
    block_name(curVal, oldVal) {
      if (curVal) {
        this.my_block_name = curVal
        this.my_level_name = 'ALL'
        this.drawBar()
      }
    },
    level_name(curVal, oldVal) {
      if (curVal) {
        this.my_level_name = curVal
        this.drawBar()
      }
    }
  }
}
</script>

<style scoped>
.miles_3_container {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  background-color: #0C283AC5;
  overflow: scroll;
}

.miles_3_top {
  width: 100%;
  height: 15%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.miles_3_title {
  color: white;
  font-size: 1rem;
  margin-left: 0.8rem;
  margin-top: 0.1rem;
}

.el-dropdown {
  padding: 0;
  margin-right: 1rem;
  margin-top: 0.2rem;
  border-radius: 0;
  display: block;
}

.el-button {
  padding: 0.1rem;
  margin: 0;
}

.el-icon-arrow-down {
  font-size: 1rem;
  position: absolute;
  right: 0.2rem;
}

.miles_3_content {
  width: 100%;
  height: 85%;
}
</style>



// WEBPACK FOOTER //
// src/components/fabrication/milestones_3.vue